import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Abacus — wooden frame, three vertical rods, a horizontal beam
 *  separating heaven (1 bead) from earth (multiple beads). Beads are
 *  filled disks; rods are thin verticals. Tuned for the soroban shape
 *  but kept loose enough to read as "calculation" generically. */
export function IcnAbacus(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="abacus">
      {/* Frame */}
      <rect x="2.25" y="3" width="11.5" height="10" rx="0.5" />
      {/* Heaven / earth separator beam */}
      <path d="M2.25 7 H13.75" />
      {/* Three rods */}
      <path d="M5.5 3 V13" />
      <path d="M8 3 V13" />
      <path d="M10.5 3 V13" />
      {/* Heaven beads — one per rod, near the beam */}
      <circle cx="5.5" cy="6" r="0.85" fill="currentColor" stroke="none" />
      <circle cx="8" cy="6" r="0.85" fill="currentColor" stroke="none" />
      <circle cx="10.5" cy="6" r="0.85" fill="currentColor" stroke="none" />
      {/* Earth beads — two per rod, stacked at the bottom */}
      <circle cx="5.5" cy="11.4" r="0.85" fill="currentColor" stroke="none" />
      <circle cx="5.5" cy="9.4" r="0.85" fill="currentColor" stroke="none" />
      <circle cx="8" cy="11.4" r="0.85" fill="currentColor" stroke="none" />
      <circle cx="8" cy="9.4" r="0.85" fill="currentColor" stroke="none" />
      <circle cx="10.5" cy="11.4" r="0.85" fill="currentColor" stroke="none" />
      <circle cx="10.5" cy="9.4" r="0.85" fill="currentColor" stroke="none" />
    </Svg>
  );
}
